import {
  ChoiceChip as CXChoiceChip,
  ChoiceGroup as CXChoiceGroup
} from '@sanlamcx/react-ui-next-choice';

export type ChoiceChip = CXChoiceChip;
export const ChoiceChip = CXChoiceChip;
export const ChoiceChipGroup = CXChoiceGroup;
